import Icon from '../../../components/AppIcon';

const ConfirmationHeader = ({ bookingReference }) => {
  return (
    <div className="bg-success/10 rounded-xl p-6 md:p-8 lg:p-10 text-center mb-6 md:mb-8">
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-success rounded-full flex items-center justify-center">
          <Icon name="CheckCircle2" size={40} color="white" />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-success mb-3">
        تم تأكيد الحجز بنجاح!
      </h1>
      <p className="text-base md:text-lg text-foreground/80 mb-4">
        شكراً لك على اختيار خدماتنا. تم إرسال تفاصيل الحجز إلى بريدك الإلكتروني
      </p>
      <div className="inline-flex items-center gap-2 bg-card px-4 md:px-6 py-3 rounded-lg">
        <Icon name="Hash" size={20} color="var(--color-primary)" />
        <span className="text-sm md:text-base font-medium">رقم الحجز:</span>
        <span className="text-base md:text-lg font-bold text-primary data-text">{bookingReference}</span>
      </div>
    </div>
  );
};

export default ConfirmationHeader;